// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"239180c4","239":"5f862d47","397":"4b6f9b04","455":"67d720cf","488":"b3aa4516","977":"81c8992c"}[chunkId] + ".chunk.js";
};